import React from 'react';
import AppRouter from './routes';
import { UpdateBanner } from './components/UpdateBanner';

function App() {
  return (
    <>
      <AppRouter />
      <UpdateBanner />
    </>
  );
}

export default App;
